import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';
import { ContactApiService, AuthenticationService, CONTRACTOR_TYPE, INSPECTOR_TYPE } from '../data-services/index';
import { AppLoadService, IUser, IHelp, HelpApiService } from '@ebb-v2/ebb-integration';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DialogSwitchDashboardComponent } from '../grant/dialog/dialog-switch-dashboard.component';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MatRipple, RippleRef } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

export interface IUserApp {
  userId: string;
  appId: string;
}

export interface IAppMenuItem {
  iconName: string;
  linkName: string;
  linkAction: string;
}

@Component({
    selector: 'ebb-portal-app-page',
    templateUrl: './app-page.component.html',
    styleUrl: './app-page.component.scss',
    standalone: false
})
export class AppPageComponent implements OnInit {
  @ViewChild(MatRipple) ripple: MatRipple;
  public uriEbbLogo: string;
  public uriEbbLogoAltText: string;
  public listHelp: IHelp[] = [];
  public listHelpTopic: string[] = [];
  public listHelpTopicItem: IHelp[] = [];

  public formOwnerSelect: FormGroup;
  public formHelpSelect: FormGroup;

  public currentUser: IUser;
  public currentUserName = '';
  public currentUserType = '';
  public modeMainMenu = 'over';
  public isMainMenuOpen = false;
  public isMainMenuPush = false;
  public formFactorIsMobile = false;

  public rippleRef : RippleRef;
  public rippleId: any;
  public isMultiUserType = false;
  public isShowTour = false;
  public screenWidth$: BehaviorSubject<number> = new BehaviorSubject(null);
  public isMobile = false;
  private MOBILE_SIZE_THRESHOLD = 600;

  
  public appMenuItems: IAppMenuItem[];
  public appMenuHomeowner: IAppMenuItem[] = [
    {'iconName': 'home', 'linkName': 'Applications', 'linkAction': 'home'},
    {'iconName': 'account_circle', 'linkName': 'User Account', 'linkAction': 'account'},
    {'iconName': 'school', 'linkName': 'Contractor Training', 'linkAction': 'train'},
    {'iconName': 'all_inbox', 'linkName': 'Contact Us', 'linkAction': 'contact'}
  ];
  public appMenuContractor: IAppMenuItem[] = [
    {'iconName': 'home', 'linkName': 'Projects', 'linkAction': 'home'},
    {'iconName': 'account_circle', 'linkName': 'User Account', 'linkAction': 'account'},
    {'iconName': 'school', 'linkName': 'Contractor Training', 'linkAction': 'train'},
    {'iconName': 'bookmark', 'linkName': 'Contractor Resources', 'linkAction': 'resources'},
    {'iconName': 'contacts', 'linkName': 'Contractor Directory', 'linkAction': 'directory'},
    {'iconName': 'storefront', 'linkName': 'Contractor Materials', 'linkAction': 'material'},
    {'iconName': 'all_inbox', 'linkName': 'Contact Us', 'linkAction': 'contact'}
  ];
  public appMenuInspector: IAppMenuItem[] = [
    {'iconName': 'home', 'linkName': 'Applications', 'linkAction': 'home'},
    {'iconName': 'account_circle', 'linkName': 'User Account', 'linkAction': 'account'},
    {'iconName': 'all_inbox', 'linkName': 'Contact Us', 'linkAction': 'contact'}
  ];

  constructor(
    private readonly deviceService: DeviceDetectorService,
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly apiAppSettings: AppLoadService,
    private readonly authenticationService: AuthenticationService,
    private readonly contactApiService : ContactApiService,
    private readonly apiHelp: HelpApiService,
    private readonly dialogSwitchDashboard: MatDialog,
    public readonly sanitizer: DomSanitizer
  ) {
    if(this.apiAppSettings.readEnvironSettings().ProgramIsCeaBb){
      this.uriEbbLogo = `${this.apiAppSettings.readEnvironSettings().uriEbbAssets}/images/ceabb.png`;
      this.uriEbbLogoAltText = 'CEA Brace+Bolt Logo';
    }
    else {
      this.uriEbbLogo = `${this.apiAppSettings.readEnvironSettings().uriEbbAssets}/images/crmp_logo.png`;
      this.uriEbbLogoAltText = 'California Residential Mitigation Program Logo';
    }

    this.authenticationService.getCurrentUserName
      .subscribe(name => this.loadCurrentUserName(name));
    this.authenticationService.getCurrentUser
      .subscribe(user =>  {
        this.currentUser = user;
        this.isMultiUserType = authenticationService.isMultiUser(this.currentUser);
        this.currentUserType = this.currentUser.mode;

        //note this our hack for mobile devices ... width 768 pixels or less
        if(this.isMultiUserType && !this.isShowTour && window.innerWidth > this.MOBILE_SIZE_THRESHOLD) {
          this.launchDashboardTour(this.currentUser);
          this.isShowTour = true;
        }

       
      });

    //monitor screen size to toggle switch dashboard options
    this.screenWidth$.next(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(1000),
      ).subscribe((evt: any) => {
        this.screenWidth$.next(evt.target.innerWidth);
      });
      this.screenWidth$.subscribe(width => {
        this.isMobile = width < this.MOBILE_SIZE_THRESHOLD;
      })
  }

  ngOnInit() {
    this.formFactorIsMobile = this.deviceService.isMobile();
    this.initializeHelpSelectForm();
    this.loadOnlineHelp();
    this.loadCurrentUserName('');
  }

  public checkIfLoggedIn(): boolean {

    const userCred = this.authenticationService.currentUserValue;
    if (userCred) {
    
      this.loadUserMenu(this.currentUserType);
      if (!this.formFactorIsMobile) {
        this.modeMainMenu = 'side';
        this.isMainMenuOpen = true;
        this.isMainMenuPush = true;
      }
      return true;
    } else {
      return false;
    }
  }

  private loadUserMenu(userType: string) : void {
    if(userType === CONTRACTOR_TYPE)  {
      this.appMenuItems = [...this.appMenuContractor];
    } else if(userType === INSPECTOR_TYPE)  {
      this.appMenuItems = [...this.appMenuInspector];
    }
    else {
      this.appMenuItems = [...this.appMenuHomeowner];
    }
  }

  private initializeHelpSelectForm(): void {
    this.formHelpSelect = this.fb.group({
      selectHelp: ''
    });
  }

  private loadOnlineHelp(): void {
    this.apiHelp.setCurrentHelpTopicValue('General Help');
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          this.loadOnlineHelpTopics();
        },
        error => console.log(error)
      );
  }

  private loadOnlineHelpTopics(): void {
    let currentTopic = '';

    this.listHelp.sort((a,b) => (a.topicCodeOptionSet > b.topicCodeOptionSet ? 1 : -1));

    this.listHelp.forEach(i => {
      if (i.includeInHelpPanel) {
        const checkTopic = i.topicCodeOptionSet;
        if (currentTopic !== checkTopic) {
          currentTopic = checkTopic;
          this.listHelpTopic.push(currentTopic);
        }
      }
    });

    this.listHelpTopic.sort((a, b) => a.localeCompare(b));

    this.formHelpSelect.get('selectHelp').setValue(this.apiHelp.currentHelpTopicValue);
    this.loadHelpTopicItems(this.apiHelp.currentHelpTopicValue);
  }

  private loadCurrentUserName(name: string): void {
    if (name && name.length > 0) {
      this.currentUserName =  name;
    }
    else {
      if (this.authenticationService.currentUserValue) {
        this.currentUserName = this.authenticationService.currentUserValue.fullName;
      }
    }
  }

  public onShowHelpDrawer(): void {
    const topic = this.apiHelp.currentHelpTopicValue;
    if (topic && topic.length > 0) {
      this.formHelpSelect.get('selectHelp').setValue(topic);
      this.loadHelpTopicItems(topic);
      this.apiHelp.setCurrentHelpTopicValue(topic);
    }
  }

  public onChangeHelpTopicEvent(value: string): void {
    const topic = value;
    if (topic && topic.length > 0) {
      this.loadHelpTopicItems(topic);
      this.apiHelp.setCurrentHelpTopicValue(topic);
    }
  }

  private loadHelpTopicItems(currentTopic: string): void {
    this.listHelpTopicItem = [];

    this.listHelp.forEach(i => {
      const checkTopic = i.topicCodeOptionSet;

      if (checkTopic === currentTopic) {     
        i.answerSafe = this.sanitizeAnswer(i.answer);;
        this.listHelpTopicItem.push(i);
      }
    })
  }
sanitizeAnswer(answer: string): SafeHtml {
  
   return this.sanitizer.bypassSecurityTrustHtml(answer);
}
  public navigateToPage(event: Event): void {
    if (this.formFactorIsMobile) {
      this.isMainMenuOpen = false;
    }
    const elementId: string = (event.currentTarget as Element).id;
    this.router.navigate([`/${elementId}`]);
  }

  public userLogout(): void {
    this.currentUserName = '';
    const b2cUrl = this.authenticationService.logoutUser();
    window.location.href = b2cUrl;
  }

  onClickSwitchDashboard() {
    const dialogViewDataItem = {
            currentUserType: this.currentUserType
    };
  
    const dialogRefSwitch = this.dialogSwitchDashboard.open(
            DialogSwitchDashboardComponent,
            { width: '400px', position: {top: '0%', left:'20%'}, data: dialogViewDataItem }
    );
  
    dialogRefSwitch.afterClosed().subscribe(result => {
      if(result && result !== this.currentUserType) {
        this.currentUserType = result;
        this.currentUser.mode = result;
        this.authenticationService.setCurrentUserValue(this.currentUser);

        //need a route switch for a complete reload
        this.router.navigate(['loading']);
      } 
    });
  }

  public isContractor() {
    return this.authenticationService.isContractor(this.currentUser);
  }

  private launchDashboardTour(user: IUser) {
    this.contactApiService.getContact(user.id)
    .subscribe(data => {
      if(data.dashboardTour === true)  {
        return;
      }

    },
    error => console.warn(error)
    );
  }


}


